/**
 * Shared breakpoint media-query strings for use with Angular's BreakpointObserver.
 * These mirror the Tailwind custom breakpoints defined in styles.css (@theme).
 *
 * Tailwind usage:  `tablet-portrait:`, `tablet-landscape:`, `laptop:`, `desktop:`, `desktop-xl:`
 * TS/CDK usage:    `BreakpointObserver.observe(LAYOUT_BREAKPOINTS.tabletPortraitUp)`
 */
export const LAYOUT_BREAKPOINTS = {
  /** Matches viewports narrower than tablet-portrait (< 600px). */
  mobileOnly: '(max-width: 599px)',

  /** Matches tablet-portrait and wider (≥ 600px). */
  tabletPortraitUp: '(min-width: 600px)',

  /** Matches viewports narrower than tablet-landscape (< 905px) — used as the "mobile" threshold. */
  mobile: '(max-width: 904px)',

  /** Matches tablet-landscape and wider (≥ 905px). */
  tabletLandscapeUp: '(min-width: 905px)',

  /** Matches viewports narrower than laptop (< 1240px). */
  belowLaptop: '(max-width: 1239px)',

  /** Matches laptop and wider (≥ 1240px). */
  laptopUp: '(min-width: 1240px)',

  /** Matches desktop and wider (≥ 1440px). */
  desktopUp: '(min-width: 1440px)',

  /** Matches desktop-xl and wider (≥ 1920px). */
  desktopXlUp: '(min-width: 1920px)',
} as const;
